import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Plus } from 'lucide-react';
import { inviteApi } from '../../lib/inviteApi';
import InviteStatusBadge from '../../components/invite/InviteStatusBadge';

const REASONS = ['do_not_contact', 'unsubscribed', 'bounced', 'complaint'];

export default function SuppressionTab() {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [email, setEmail] = useState('');
  const [reason, setReason] = useState('do_not_contact');
  const [note, setNote] = useState('');

  const refresh = async () => {
    setLoading(true);
    try { setList(await inviteApi.listSuppression()); }
    finally { setLoading(false); }
  };
  useEffect(() => { refresh(); }, []);

  const add = async () => {
    if (!email.trim()) return;
    try {
      await inviteApi.addSuppression({ email: email.trim(), reason, note });
      toast.success('Added to suppression');
      setEmail(''); setNote(''); refresh();
    } catch (err) { toast.error(err.response?.data?.detail || 'Failed'); }
  };

  return (
    <div className="space-y-4" data-testid="suppression-tab">
      <div className="border border-[#1a1a1a] bg-[#0a0a0a] p-4 grid grid-cols-1 sm:grid-cols-4 gap-2">
        <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="email@example.com" data-testid="suppression-email" className="invite-input" />
        <select value={reason} onChange={(e) => setReason(e.target.value)} className="invite-select">
          {REASONS.map((r) => <option key={r} value={r}>{r.replace(/_/g, ' ')}</option>)}
        </select>
        <input value={note} onChange={(e) => setNote(e.target.value)} placeholder="note (optional)" className="invite-input" />
        <button onClick={add} data-clickable="true" data-testid="suppression-add" className="inline-flex items-center justify-center gap-1.5 text-[10px] font-mono px-3 py-2 border border-[#90E0EF]/40 text-[#90E0EF] hover:bg-[#90E0EF]/10 uppercase tracking-[0.14em]">
          <Plus className="w-3 h-3"/> Add
        </button>
      </div>

      <div className="border border-[#1a1a1a] overflow-x-auto">
        <table className="w-full text-[11px] font-mono">
          <thead className="text-[#666] uppercase tracking-[0.14em]">
            <tr className="border-b border-[#161616]">
              <th className="text-left p-2.5">Email</th>
              <th className="text-left p-2.5">Reason</th>
              <th className="text-left p-2.5">Note</th>
              <th className="text-left p-2.5">Added</th>
            </tr>
          </thead>
          <tbody>
            {loading && <tr><td colSpan={4} className="p-4 text-[#555]">Loading…</td></tr>}
            {!loading && !list.length && <tr><td colSpan={4} className="p-4 text-[#555]">No suppressed addresses.</td></tr>}
            {list.map((s) => (
              <tr key={s.id} className="border-b border-[#0e0e0e]">
                <td className="p-2.5 text-white">{s.email}</td>
                <td className="p-2.5"><InviteStatusBadge status={s.reason} /></td>
                <td className="p-2.5 text-[#888]">{s.note || '—'}</td>
                <td className="p-2.5 text-[#666]">{new Date(s.created_at).toLocaleDateString()}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
